'use client';

import { useEffect, useState } from 'react';
import NewsList from './NewsCardClient';

const getNewsCount = (width: number) => {
  if (width >= 1025) return 4;
  if (width >= 768) return 3; 
  return 4;
};

const Newscard = () => {
  // Use any[] temporarily, or better, unknown[]
  const [newsItems, setNewsItems] = useState<any[]>([]);
  const [displayCount, setDisplayCount] = useState<number>(4);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('/api/news')
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data: any) => {
        // Ensure data is an array before setting
        if (Array.isArray(data)) {
          setNewsItems(data);
        } else {
          console.error('API did not return an array:', data);
          setNewsItems([]);
        }
        setLoading(false);
      })
      .catch((err: Error) => {
        console.error('Error fetching news:', err);
        setError(err.message);
        setNewsItems([]);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const count = getNewsCount(window.innerWidth);
      setDisplayCount(count);
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const displayedNews = newsItems.slice(0, displayCount);

  if (loading) {
    return <div className="text-center py-4">Loading news...</div>;
  }

  if (error) {
    return <div className="text-center py-4 text-red-500">Error loading news: {error}</div>;
  }

  return <NewsList newsItems={displayedNews} />;
};

export default Newscard;